<template>
  <div class="top-bar">
    <div class="top-bar-left">
      <slot name="left"></slot>
    </div>
    <div class="top-bar-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
};
</script>

<style scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  margin-bottom: 1.2rem;
  box-shadow: 0 2px 8px var(--gray-light);
  border-radius: 12px;
  background: var(--white);
}
.top-bar-left,
.top-bar-right {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.top-bar .btn {
  background: #f7f8fa;
  color: var(--gray-darker);
  border: 1px solid var(--gray-light);
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.93rem;
  font-weight: 500;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.03);
  white-space: nowrap;
  margin: 0;
}
.top-bar .btn:hover {
  background: var(--brand-primary);
  color: #fff;
  border-color: var(--brand-primary);
}
.top-bar .btn-report-special {
  min-width: 140px;
  background: var(--brand-primary);
  color: #fff;
  border: 1px solid var(--brand-primary);
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(1,158,135,0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.top-bar .btn-report-special:hover {
  background: #019e87;
  border-color: #019e87;
  color: #fff;
}
.top-bar .btn-report-special i {
  margin-right: 0.5rem;
  font-size: 1.1em;
}
</style>
